<template>
  <div class="default-role">
    <div class="head">
      <!-- <img src="~_img/common/head-icon.png" alt="" /> -->
      <svg-icon :icon-class="'data-source'" />
      <span>默认角色管理</span>
    </div>
    <div class="query common-bg">
      <x-query :form="queryForm" :formArr="queryList" @query="getList" @reset="getList"></x-query>
    </div>
    <div class="content-wrap">
      <div class="warning">
        <img src="~_img/common/danger.png" alt="" />
        <div class="text">
          <div class="t2">
            需先进行“模块配置”，再设置“默认角色”！<span
              @click="$router.push({ path: $route.fullPath, query: { menu: 'moduleConfig' } })"
              >模块配置管理>></span
            >
          </div>
        </div>
        <IviewButton type="primary" @click="openDialog({}, 'add')"><Icon type="md-add" />添加默认角色</IviewButton>
      </div>
      <IviewTable :data="tableData" :columns="tableCol" :page="pager" @on-page-change="changePageSize">
        <div slot="scope" slot-scope="{ row }">
          <span v-if="row.parentManageRange == 1">指定组织</span>
          <span v-else-if="row.parentManageRange == 2">归属组织及全部下级组织</span>
          <span v-else-if="row.parentManageRange == 3">归属组织及下级组织</span>
          <span v-else-if="row.parentManageRange == 4">归属组织</span>
        </div>
        <div slot="enable" slot-scope="{ row }">
          <span v-if="row.enable" style="color: #1ab8a5">启用</span>
          <span v-else style="color: #b8321a">禁用</span>
        </div>
        <div slot="dataScope" slot-scope="{ row }">
          <span v-if="row.manageRange == 0">仅本人</span>
          <span v-else-if="row.manageRange == 1">指定部门</span>
          <span v-else-if="row.manageRange == 2">归属部门和全部下级部门</span>
          <span v-else-if="row.manageRange == 3">全部部门</span>
          <span v-else-if="row.manageRange == 4">归属部门</span>
        </div>

        <ul class="table-cao" slot="cao" slot-scope="{ row }">
          <li @click="openDialog(row, 'edit')">编辑</li>
          <li @click="openDialog(row, 'enable')">
            <span v-if="row.enable" style="color: #b8321a">禁用</span>
            <span v-else>启用</span>
          </li>
          <li v-if="!row.enable" @click="openDialog(row, 'del')" class="del">删除</li>
        </ul>
      </IviewTable>
    </div>
    <IviewModal
      title="修改状态"
      type="confirm"
      v-model="enablePopup"
      @on-ok="isEnableRole"
      :confirmText2="`是否${currentTableData.enable ? '禁用' : '启用'}该角色?`"
    ></IviewModal>
    <IviewModal
      title="删除默认角色"
      type="confirm"
      v-model="delPopup"
      @on-ok="delRole"
      :confirmText2="`是否删除该角色?`"
    ></IviewModal>
    <AddDefaultRole v-model="nodePopup" :data="currentTableData" @refresh="getList"></AddDefaultRole>
  </div>
</template>
<script>
import AddDefaultRole from './modules/addDefaultRole.vue'
export default {
  components: { AddDefaultRole },
  data() {
    return {
      queryForm: {},
      queryList: [
        { label: '组织树节点', key: 'orgLevel' },
        { label: '节点别名', key: 'orgLevelName' },
        { label: '角色名称', key: 'name' }
      ],
      tableData: [],
      tableCol: [
        { title: '组织树节点', key: 'orgLevel', align: 'center' },
        { title: '节点别名', key: 'orgLevelName', align: 'center' },
        { title: '角色名称', key: 'name', align: 'center' },
        { title: '管理范围', slot: 'scope', align: 'center' },
        { title: '数据权限', slot: 'dataScope', align: 'center' },
        { title: '状态', slot: 'enable', align: 'center' },
        { title: '操作', slot: 'cao', align: 'center' }
      ],
      pager: {
        total: 0
      },
      currentTableData: {},
      nodePopup: false,
      enablePopup: false,
      delPopup: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList(params) {
      this.$api.config.getDefaultRole({ pageNum: 1, pageSize: 10, ...params }).then((res) => {
        this.tableData = res.data.records
        this.pager.total = res.data.total
      })
    },
    isEnableRole() {
      let { enable, id, orgLevel } = this.currentTableData
      this.$api.config.putDefaultRole({ ...this.currentTableData, enable: !enable }, [orgLevel, id]).then((res) => {
        this.$Message.success('操作成功')
        this.enablePopup = false
        this.getList()
      })
    },
    delRole() {
      let { hierachyId, id } = this.currentTableData
      this.$api.role.delRole({}, [hierachyId, id]).then((res) => {
        this.$Message.success('删除成功')
        this.getList()
        this.delPopup = false
      })
    },
    changePageSize(e) {
      this.getList(e)
    },
    openDialog(row, type) {
      this.currentTableData = { ppType: 'edit', ...row }
      if (type == 'edit') {
        this.nodePopup = true
      } else if (type == 'add') {
        this.currentTableData.ppType = 'add'
        this.nodePopup = true
      } else if (type == 'enable') {
        this.enablePopup = true
      } else {
        this.delPopup = true
      }
    }
  }
}
</script>
<style lang="less">
.ivu-btn {
  max-width: 400px;
}
</style>
<style lang="less" scoped>
.default-role {
  background: #f2f3f4;
  padding: 0 !important;
  .head {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px;
    img {
      width: 18px;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2c3542;
      margin-left: 8px;
    }
  }
  .query {
    margin-top: 20px;
    padding: 0;
  }
  .content-wrap {
    padding: 20px;
    margin-top: 20px;
    background: #fff;
    .warning {
      display: flex;
      align-items: center;
      background: #f3e9e9;
      border-radius: 4px;
      padding: 10px 14px;
      margin-bottom: 14px;
      img {
        width: 19px;
        height: 19px;
      }
      .text {
        flex: 1;
        margin-left: 10px;
        .t1,
        .t2 {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #be5a57;
          margin: 4px 0;
        }
        .t2 span {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2c46b5;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
  /deep/.i-table {
    .ivu-table-wrapper {
      height: calc(100vh - 480px);
    }
    .i-page {
      bottom: -44px;
    }
  }
}
</style>
